import { HeartIcon, ShareIcon } from "@heroicons/react/24/outline";
import { HeartIcon as HeartIconSolid } from "@heroicons/react/24/solid";
import { OutfitCardProps } from "../../types/Profile";

export default function OutfitCard({ 
  outfit, 
  onToggleFavourite, 
  isFavourited 
}: OutfitCardProps) {
  return (
    <div className="group relative overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-sm hover:shadow-xl transition-all duration-500">
      <div className="aspect-square overflow-hidden">
        <img
          src={outfit.imageUrl || 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=400'}
          alt={`Outfit for ${outfit.occasion}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Actions */}
      <div className="absolute top-4 right-4 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <button
          onClick={() => onToggleFavourite(outfit.id)}
          className="rounded-full bg-white/90 dark:bg-gray-900/90 p-2 backdrop-blur-sm hover:scale-110 transition-transform duration-200"
        >
          {isFavourited ? (
            <HeartIconSolid className="h-5 w-5 text-red-500" />
          ) : (
            <HeartIcon className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          )}
        </button>
        <button className="rounded-full bg-white/90 dark:bg-gray-900/90 p-2 backdrop-blur-sm hover:scale-110 transition-transform duration-200">
          <ShareIcon className="h-5 w-5 text-gray-600 dark:text-gray-300" />
        </button>
      </div>
      
      {/* Hover Content */}
      <div className="absolute bottom-0 left-0 right-0 p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <h3 className="text-lg font-light tracking-wider uppercase">
          {outfit.occasion}
        </h3>
        <p className="mt-1 text-sm text-gray-200">
          {outfit.outfitItems?.length || 0} pieces
        </p>
      </div>
      
      {/* Default Content */}
      <div className="p-4 group-hover:opacity-0 transition-opacity duration-300">
        <h3 className="text-lg font-light tracking-wider uppercase text-gray-900 dark:text-white">
          {outfit.occasion}
        </h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {outfit.outfitItems?.length || 0} pieces
        </p>
      </div>
    </div>
  );
}